import { useSelector } from 'react-redux';
import { RoleGetResult } from '@mews-commander/data-access';
import { isCurrentEnterprisePortfolio } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { isCurrentEnterprisePartOfPortfolio } from '@mews-commander/legacy-entities/src/ducks/enterprises';
import { hasCurrentEnterpriseMultiPropertyAccess } from '@mews-commander/legacy-entities/src/selectors/session/enterpriseProductSubscriptions';

export const isRoleDeletable = (role: RoleGetResult, isPortfolio: boolean) => {
    const hasNoUsers = (role.userCount ?? 0) === 0;
    const isCentralRoleInPMS = !role.isLocal && !isPortfolio;

    return !isCentralRoleInPMS && hasNoUsers;
};

export const usePortfolioSelectors = (): {
    isPortfolio: boolean;
    isInsidePortfolio: boolean;
    hasMultiPropertyAccess: boolean;
} => {
    const isPortfolio = !!useSelector(isCurrentEnterprisePortfolio);
    const isInsidePortfolio = !!useSelector(isCurrentEnterprisePartOfPortfolio);
    const hasMultiPropertyAccess = !!useSelector(hasCurrentEnterpriseMultiPropertyAccess);

    return {
        isPortfolio,
        isInsidePortfolio,
        hasMultiPropertyAccess,
    };
};
